import { useState } from "react";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";

import FilterIcon from "@mui/icons-material/FilterAlt";
import AppSettingsAltIcon from "@mui/icons-material/AppSettingsAlt";

import { useIsMobile } from "../../hooks/useIsMobile";
import { useNitroStore } from "../../store/Store";
import FilterOptions from "./tabs/filterOptions";

import "./index.css";
import MapOptions from "./tabs/mapOptions";
import useEscapeKeyExit from "../../hooks/useEscapeKeyExit";
import DebugOptions from "./tabs/debugOptions";

const SettingsPanel = ({
  onFooterSelect,
}: {
  onFooterSelect?: (tab: any) => void;
}) => {
  const isMobile = useIsMobile(768);

  const [showSettingsPanel, setShowSettingsPanel] = useNitroStore((state) => [
    state.showSettingsPanel,
    state.setShowSettingsPanel,
  ]);

  useEscapeKeyExit({
    active: showSettingsPanel,
    close: () => setShowSettingsPanel(false),
  });

  const [tab, setTab] = useState<"filter" | "map" | "debug">("filter");

  if (!showSettingsPanel) {
    return null;
  }

  return (
    <>
      <div
        id="hideMap"
        style={{
          position: "fixed",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 12000,
          backgroundColor: "rgba(15, 44, 82, 0.3)", // Selecting pin location
          overflow: "hidden",
        }}
      />
      <div
        className="settingsPanel"
        style={{
          width: isMobile ? "100vw" : 600,
          display: "flex",
          flexDirection: "column",

          backgroundColor: "#F7F7F7",
          boxShadow:
            "0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
        }}
      >
        {/* HEADER */}
        <div
          style={{
            width: "100%",
            height: 100,
            minHeight: 100,
            display: "flex",
            alignItems: "center",
            position: "relative",
          }}
        >
          <div
            style={{
              paddingLeft: 14,
              fontWeight: 500,
              fontSize: 26,
              width: "100%",
              textAlign: "center",
            }}
          >
            Settings
          </div>
        </div>
        {/* END HEADER */}

        <BottomNavigation
          value={tab}
          style={{
            backgroundColor: "#F7F7F7",
            borderTop: "1px solid #E0E0E0",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <BottomNavigationAction
            style={{ height: 60 }}
            showLabel
            icon={<FilterIcon />}
            label="Filter settings"
            value="filter"
            onClick={() => setTab("filter")}
          />
          <BottomNavigationAction
            showLabel
            icon={<AppSettingsAltIcon />}
            label="Debug"
            value="debug"
            onClick={() => setTab("debug")}
          />
        </BottomNavigation>

        <div style={{ height: "100%", display: "flex", overflow: "hidden" }}>
          <div
            style={{
              height: "100%",
              width: tab === "filter" ? "100%" : 0,
              overflow: "hidden",
              display: "flex",
            }}
          >
            <FilterOptions
              close={() => setShowSettingsPanel(false)}
              onFooterSelect={onFooterSelect}
            />
          </div>
          <div
            style={{
              height: "100%",
              width: tab === "map" ? "100%" : 0,
              overflow: "hidden",
              display: "flex",
            }}
          >
            <MapOptions
              close={() => setShowSettingsPanel(false)}
              onFooterSelect={onFooterSelect}
            />
          </div>

          <div
            style={{
              height: "100%",
              width: tab === "debug" ? "100%" : 0,
              overflow: "hidden",
              display: "flex",
            }}
          >
            <DebugOptions
              close={() => setShowSettingsPanel(false)}
              onFooterSelect={onFooterSelect}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default SettingsPanel;
